<template>
  <v-container class="minHeight">
    <v-card>
      <v-tabs v-model="tab" grow class="pt-2" color="tranparent">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          key="profile"
          active-class="default-class primary--text"
          class="initialize"
        >
          {{ $t('profile.tab.name') }}
        </v-tab>
        <v-tab
          key="password"
          active-class="default-class primary--text"
          class="initialize"
        >
          {{ $t('profile.tab.password') }}
        </v-tab>
        <v-tab
          key="username"
          active-class="default-class primary--text"
          class="initialize"
        >
          {{ $t('profile.tab.username') }}
        </v-tab>
        <v-tab
          key="phone"
          active-class="default-class primary--text"
          class="initialize"
        >
          {{ $t('profile.tab.phone') }}
        </v-tab>
        <v-tab
          key="plates"
          v-if="hasBle"
          active-class="default-class primary--text"
          class="initialize"
        >
          {{ $t('profile.tab.plate') }}
        </v-tab>
        <v-tab
          key="creditcards"
          active-class="default-class primary--text"
          class="initialize"
        >
          {{ $t('profile.tab.creditcards') }}
        </v-tab>
        <v-tab
          key="circles"
          active-class="default-class primary--text"
          class="initialize"
        >
          {{ $t('profile.tab.circles') }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="profile">
          <change-name></change-name>
        </v-tab-item>
        <v-tab-item key="password">
          <change-password></change-password>
        </v-tab-item>
        <v-tab-item key="username">
          <change-username></change-username>
        </v-tab-item>
        <v-tab-item key="phone">
          <change-phone></change-phone>
        </v-tab-item>
        <v-tab-item key="plates" v-if="hasBle">
          <plates-list></plates-list>
        </v-tab-item>
        <v-tab-item key="creditcards">
          <creditCards-list></creditCards-list>
        </v-tab-item>
        <v-tab-item key="circles">
          <circles-list></circles-list>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import ChangeName from '@/components/private/user/ChangeName';
import ChangePassword from '@/components/private/user/ChangePassword';
import ChangeUsername from '@/components/private/user/ChangeUsername';
import ChangePhone from '@/components/private/user/ChangePhone';
import PlatesList from '@/components/private/user/PlatesList';
import CreditCardsList from '@/components/private/user/CreditCardsList';
import CirclesList from '@/components/private/user/CirclesList';
import store from '@/store';

export default {
  name: 'Profile',
  components: {
    [ChangeName.name]: ChangeName,
    [ChangePassword.name]: ChangePassword,
    [ChangeUsername.name]: ChangeUsername,
    [ChangePhone.name]: ChangePhone,
    [PlatesList.name]: PlatesList,
    [CreditCardsList.name]: CreditCardsList,
    [CirclesList.name]: CirclesList
  },
  computed: {
    token() {
      // Usado como callback de cambio de username
      return this.$route.query.token;
    },
    username() {
      // Usado como callback de cambio de username
      return this.$route.query.username;
    },
    newUsername() {
      // Usado como callback de cambio de username
      return this.$route.query.newUsername;
    }
  },
  data() {
    return {
      tab: null,
      hasBle: store.state.countrySelected.hasBle
    };
  },
  created() {
    if (this.token && this.username && this.newUsername) {
      this.tab = 2;
    }
  },
  mounted() {
    if (typeof this.$route.query.tab !== 'undefined') {
      if (this.$route.query.tab === 'phone') {
        this.tab = 3;
      }
    }
  }
};
</script>
